var switchFlags = function switchFlags(switches, defaultValue) {
  return function (props) {
    var name = Object.keys(switches).find(function (name) {
      return props[name];
    });
    return name ? switches[name] : defaultValue;
  };
};
export default switchFlags;